/* eslint-disable no-confusing-arrow */
const { formatImage, formatUrl } = require('@ifeng/public_method');

const handleChildrenData = data => {
    try {
        if (data) {
            return data.map(item => ({
                url: item.url,
                title: item.title,
                pcNewsMark: (item.extentData && item.extentData.pcNewsMark) || item.pcNewsMark,
            }));
        }
    } catch (error) {
        console.error(error);
    }

    return null;
};

const handleThumbnail = (data, w, h) => {
    try {
        const imageUrl = data?.thumbnails?.image[0]?.url || data.thumbnail;

        if (imageUrl) {
            return formatImage(imageUrl, w, h);
        }
    } catch (error) {
        console.error(error);
    }

    return '';
};

const getTimeStamp = time => {
    if (time) {
        return new Date(time).getTime();
    } else {
        return new Date().getTime();
    }
};

module.exports = {
    jsonParse: data => {
        try {
            return JSON.parse(data);
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    // 电商结构化碎片数据处理
    handleShopStructData: (data = {}, hasAdMark = true) => {
        const dataList = Object.values(data).map(item => {
            const currentTime = getTimeStamp();
            const basicData = {
                title: item?.title || '',
                url: item?.url || '',
                thumbnail: item?.thumbnail || '',
                isAddBold: item?.isAddBold ?? false,
                hasAdIcon: item?.hasAdIcon ?? true,
            };
            let pcNewsMark = [];
            let resultData = {};
            let listData = item.list || [];

            listData = listData.filter(item => {
                const startTime = getTimeStamp(item.startTime);
                const endTime = (item.endTime && getTimeStamp(item.endTime)) || 0;
                // 当前时间"大于"开始时间"
                const isGreaterThanStartTime = currentTime > startTime;
                let isLessThanEndTime = true;

                // 如果有"结束时间"的话，"当前时间"小于"结束时间"
                if (endTime !== 0) {
                    if (currentTime < endTime) {
                        isLessThanEndTime = true;
                    } else {
                        isLessThanEndTime = false;
                    }
                }

                return isGreaterThanStartTime && isLessThanEndTime;
            });

            // 按照"开始时间"距离"当前时间"多少进行降序，获取获取第一条
            listData = listData.sort((a, b) => {
                const aTime = getTimeStamp(a.startTime);
                const bTime = getTimeStamp(b.startTime);

                return bTime - aTime;
            });

            if (listData.length > 0) {
                // 如筛选后的更新数据大于1条的话，显示第一条
                resultData = listData[0];
            } else {
                // 如更新数据不满足筛选规则，或者为空的话，显示打底数据
                resultData = basicData;
            }

            // 标题是否加粗
            if (resultData?.isAddBold) {
                pcNewsMark.push(1);
            }
            // 是否添加广告标签
            if (hasAdMark) {
                pcNewsMark.push(5);
            }

            // 广告标签控制开关
            if (resultData?.hasAdIcon === false) {
                pcNewsMark = pcNewsMark.filter(item => item !== 5);
            }

            return {
                ...resultData,
                pcNewsMark,
            };
        });

        return dataList;
    },
    // 处理要闻焦点图
    handleNewsSlideData: (data, name) => {
        try {
            return data.map(item => ({
                thumbnail:
                    name && name.includes('newsSlidePhtv')
                        ? handleThumbnail(item, 360, 203)
                        : handleThumbnail(item, 480, 270),
                url: item.url,
                title: item.title,
                pcNewsMark: item.pcNewsMark,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    // 处理文字链列表
    handleNewsTopData: data => {
        try {
            return data.slice(0, 3).map(item => ({
                url: item.url,
                title: item.title,
                marquee: item.marquee,
                pcNewsMark: item.pcNewsMark,
                children: handleChildrenData(item.children),
            }));
        } catch (error) {
            console.error(error);
        }

        return data.slice(0, 3);
    },
    handleNewsListData: data => {
        try {
            return data.slice(0, 15).map(item => ({
                url: item.url,
                title: item.title,
                marquee: item.marquee,
                pcNewsMark: item.pcNewsMark,
                children: handleChildrenData(item.children),
            }));
        } catch (error) {
            console.error(error);
        }

        return data.slice(0, 15);
    },
    handleGovListData: data => {
        try {
            return data.slice(0, 2).map(item => ({
                url: item.url,
                title: item.title,
                pcNewsMark: item.pcNewsMark,
                children: handleChildrenData(item.children),
            }));
        } catch (error) {
            console.error(error);
        }

        return data.slice(0, 2);
    },
    // 处理文字链列表
    handleNewsData: data => {
        try {
            return data.map(
                (item, index) =>
                    index === 0
                        ? {
                              url: item.url,
                              title: item.title,
                              pcNewsMark: item.pcNewsMark,
                              newsTime: item.newsTime,
                              thumbnail: handleThumbnail(item, 175, 98),
                              children: handleChildrenData(item.children),
                          }
                        : {
                              url: item.url,
                              title: item.title,
                              pcNewsMark: item.pcNewsMark,
                              children: handleChildrenData(item.children),
                          },
            );
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    // 处理视频盒数据
    handleVideoBoxData: data => {
        try {
            return data.map(item => ({
                thumbnail: handleThumbnail(item, 175, 98),
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
    // 处理新闻盒数据
    handleNewsBoxData: data => {
        try {
            return data.map(item => ({
                thumbnail: handleThumbnail(item, 230, 130),
                url: item.url,
                title: item.title,
            }));
        } catch (error) {
            console.error(error);
        }

        return data;
    },
};
